import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import 'react-loading-skeleton/dist/skeleton.css';
import { updateacademic, getacademic, deleteacademics } from '../../ReduxToolkit/Slice/Academic/Academic';
import JoditEditor from 'jodit-react';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import PageTitle from '../../components/Title/PageTitle';
import { ToastContainer } from "react-toastify";
import AcademicForm from './AcademicForm';
import CommanTable from '../../components/Table/CommanTable';

function Academic() {
  const dispatch = useDispatch();
  const closeButtonRef = useRef(null);
  const { status, academics } = useSelector((state) => state.academic);
  const [Image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getacademic())
    }
  }, [dispatch, status]);

  // delete api
  const handleDelete = (academicid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this Academic?")
    if (Isconfirmed) {
      dispatch(deleteacademics(academicid))
    };
  }
  // single data fetch
  const [selectedId, setSelectedId] = useState(null);
  const handlid = (id) => {
    const selecteacademic = academics.data.find(academic => academic._id === id);
    setTitle(selecteacademic.title);
    setImage(selecteacademic.Image);
    setDescription(selecteacademic.description);
    setSelectedId(id);
  };
  // update
  const handleEdit = (e) => {
    e.preventDefault()
    const formData = new FormData();
    formData.append('Image', Image === null ? "" : Image);
    formData.append('title', title);
    formData.append('description', description);
    dispatch(updateacademic({ selectedId, formData }));
    closeButtonRef.current.click();
    setImage(null);
    setTitle("");
    setDescription("");
  }
  // date Destructuring
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined,
    );
  }

  const columns = [
    { label: "Title", accessor: "title" },
    { label: "Description", accessor: "description" },
    { label: "Date", accessor: "createdAt", formatter: formatDate },
  ];
  return (

    <>
      <div>
        <ToastContainer />
        <div className='d-flex justify-content-between my-3'>
          <PageTitle children={"Acadamic"} />
          <AcademicForm />
        </div>
        <CommanTable
          columns={columns}
          data={academics.data || []}
          status={status}
          onDelete={handleDelete}
          onEdit={handlid}
          databstarget="#exampleModalEdit"
          model="modal"
        />
      </div>
      {/* Modal Edit  */}
      <div
        className="modal fade"
        id="exampleModalEdit"
        tabIndex={-1}
        aria-labelledby="exampleModalLabeledit"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <PageTitle className={"modal-title fs-5"} children={"Update Academic"} />
              <Button
                type="button"
                bgColor='white'
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form action="" onSubmit={handleEdit}>
                <Input
                  label="Title"
                  type="text"
                  placeholder="Enter title"
                  value={title}
                  required
                  onChange={(e) => setTitle(e.target.value)}
                />
                <Input
                  label="Image"
                  type="file"
                  placeholder="Email"

                  onChange={(e) => setImage(e.target.files[0])} />

                <div className="mb-3 col-lg-12">
                  <label htmlFor="content" className="form-label">
                    description
                  </label>
                  <JoditEditor
                    required={true}
                    value={description}
                    tabIndex={1} // 
                    onBlur={newdescription => setDescription(newdescription)}
                    onChange={newdescription => { }}
                  />
                </div>


                <div className={`modal-footer`}>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={closeButtonRef}
                  >
                    Close
                  </button>
                  <Button type="submit" children={"Upload"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Academic;
